import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'
import { Label } from '@subaio/components/src/ButtonLoading/Label'

import { helpers } from 'styles'

export const ButtonLink = styled(ButtonAsync)`
	color: ${({ theme }) => theme.color.primary};
	background-color: transparent;
	font-family: ${helpers.font.family.header};
	font-weight: 500;
	font-size: ${helpers.font.size.base};
	line-height: 1.2;

	height: 32px;
	padding-left: 4px;
	padding-right: 4px;
	border-radius: 8px;
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;
	margin: 0 0 4px;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => transparentize(0.92, theme.color.primary)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}

	> ${Label} {
		display: flex;
		align-items: center;
		column-gap: 8px;
	}
`
